module.exports = __webpack_public_path__ + "static/img/boss_customergrid.7d25e3f2.png";